module.exports = __webpack_public_path__ + "img/blue_118.b82e440b.png";